import { Fragment } from "react";
import { CardBody, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoCallOutline, IoFlagOutline } from "react-icons/io5";
import { useSettings } from "../../../../../../context/settings";
import NotesSection from "../../../../components/Sections/Notes";
import AttachmentsSection from "../../../../components/Sections/Attachments";
import { Field, SectionCard } from "../../../../components/Record";
import { formatMinutes, personName, printCallStatus, printCallType } from "../../../../utils/helpers";

function OverviewTab({ callData }) {
  const { t } = useTranslation();
  const { formatDateTime } = useSettings();

  const customer = callData?.customer;
  const customerName = customer?.company_name || personName(customer);

  return (
    <Fragment>
      <SectionCard
        id="call-informations-card"
        icon={<IoCallOutline size={15} />}
        title={t('crm.callInformationsSection')}
      >
        <CardBody>
          <Row className="g-3">
            <Field label={t('crm.callFor')}>
              {customer?.id ? (
                <Link
                  to={"/crm/customers/view/" + customer.id}
                  state={{ customerData: customer }}
                  className="crm-record-value text-decoration-none"
                >
                  {customerName}
                </Link>
              ) : callData?.lead_id ? (
                <Link to={"/crm/leads/view/" + callData.lead_id} className="crm-record-value text-decoration-none">
                  {t('crm.lead')}
                </Link>
              ) : (
                <div className="crm-record-value">-</div>
              )}
            </Field>
            <Field label={t('crm.relatedTo')} value={personName(callData?.employee)} />
            <Field label={t('common.subject')} value={callData?.subject} />
            <Field label={t('crm.callType')}>
              {printCallType(callData?.call_type) || <div className="crm-record-value">-</div>}
            </Field>
            <Field label={t('common.status')}>
              {printCallStatus(callData?.status) || <div className="crm-record-value">-</div>}
            </Field>
            <Field
              label={t('crm.callStartTime')}
              value={callData?.call_start_time ? formatDateTime(callData.call_start_time) : null}
            />
            <Field label={t('common.duration')} value={formatMinutes(callData?.call_duration)} />
            <Field label={t('timeline.createdBy')} value={personName(callData?.created_by)} />
          </Row>
        </CardBody>
      </SectionCard>

      <SectionCard
        id="call-purpose-card"
        icon={<IoFlagOutline size={15} />}
        title={t('crm.purposeOfCall')}
      >
        <CardBody>
          <Row className="g-3">
            <Field label={t('crm.callPurpose')} value={callData?.call_purpose} lg="6" />
            <Field label={t('crm.callResult')} value={callData?.call_result} lg="6" />
            <Field label={t('common.description')} value={callData?.purpose_description} lg="12" />
            <Field label={t('crm.outcome')} value={callData?.outcome_description} lg="12" />
          </Row>
        </CardBody>
      </SectionCard>

      <NotesSection objectData={callData} objectType="call" />

      <AttachmentsSection objectData={callData} objectType="call" />
    </Fragment>
  );
}

export default OverviewTab;
